module.exports = "<col-alert *ngFor=\"let alert of alerts\" [alert]=\"alert\"></col-alert>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/alert/alert-container/alert-container.component.html
// module id = ./src/app/common/alert/alert-container/alert-container.component.html
// module chunks = main